import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate } from "react-router-dom";
import { title } from "../config/Config";

// ── apni images import karo ──
import mainImg1 from "../Assets/Images/product_img1.jpg";
import mainImg2 from "../Assets/Images/product1.jpg";
import mainImg3 from "../Assets/Images/product2.jpg";
import mainImg4 from "../Assets/Images/product_img1.jpg";
import mainImg5 from "../Assets/Images/product1.jpg";

import product_img1 from "../Assets/Images/product1.jpg";
import product_img3 from "../Assets/Images/product2.jpg";
import product_img4 from "../Assets/Images/product_img1.jpg";

// ────────────────────────────────────────────
//  PRODUCT DETAIL
// ────────────────────────────────────────────
const ProductDetail = () => {
  const navigate = useNavigate();

  const productImages = [mainImg1, mainImg2, mainImg3, mainImg4, mainImg5];

  const [mainImg, setMainImg] = useState(productImages[0]);
  const [quantity, setQuantity] = useState(1);
  const [zoomed, setZoomed] = useState(false);
  const [zoomPos, setZoomPos] = useState({ x: 50, y: 50 });
  const [time, setTime] = useState({ hours: 0, minutes: 11, seconds: 19 });

  useEffect(() => {
    const timer = setInterval(() => {
      setTime((prev) => {
        let { hours, minutes, seconds } = prev;
        if (seconds > 0) return { hours, minutes, seconds: seconds - 1 };
        if (minutes > 0) return { hours, minutes: minutes - 1, seconds: 59 };
        if (hours > 0) return { hours: hours - 1, minutes: 59, seconds: 59 };
        clearInterval(timer);
        return { hours: 0, minutes: 0, seconds: 0 };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const pad = (n) => String(n).padStart(2, "0");

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setZoomPos({
      x: ((e.clientX - rect.left) / rect.width) * 100,
      y: ((e.clientY - rect.top) / rect.height) * 100,
    });
  };

  return (
    <div className="product_detail_sec">
      <Container>
        <Row>
          {/* ── LEFT: IMAGES ── */}
          <Col lg={6} className="sticky_img_col">
            <div className="product_images">
              {/* Main Image */}
              <div
                className={`main_img_wrap ${zoomed ? "zoomed" : ""}`}
                onMouseEnter={() => setZoomed(true)}
                onMouseLeave={() => setZoomed(false)}
                onMouseMove={handleMouseMove}
                style={{
                  backgroundImage: `url(${mainImg})`,
                  backgroundPosition: zoomed
                    ? `${zoomPos.x}% ${zoomPos.y}%`
                    : "center",
                }}
              >
                <img src={mainImg} alt="Product" className="main_img" />
              </div>

              {/* Thumbnails */}
              <div className="thumbnails">
                {productImages.map((img, i) => (
                  <div
                    key={i}
                    className={`thumb ${mainImg === img ? "active" : ""}`}
                    onClick={() => setMainImg(img)}
                  >
                    <img src={img} alt={`thumb-${i}`} />
                  </div>
                ))}
              </div>
            </div>
          </Col>

          {/* ── RIGHT: INFO ──  scroll_info_col*/}
          <Col lg={6} className="">
            <div className="product_info">
              <p className="brand_name">{title}</p>

              <h1 className="product_title">
                Light N Care Anti Blemish Cream – Ayurvedic Formula with Green
                Tea & Aloe Vera Extract (50g)
              </h1>

              <div className="price_row">
                <span className="original_price">Rs. 1,200.00</span>
                <span className="sale_price">Rs. 899.00</span>
                <span className="sale_badge">Sale</span>
              </div>

              <p className="shipping_note">
                <a href="#">Shipping</a> calculated at checkout.
              </p>

              {/* Quantity */}
              <div className="qty_section">
                <label>Quantity</label>
                <div className="qty_controls">
                  <button
                    onClick={() => setQuantity((q) => Math.max(1, q - 1))}
                  >
                    −
                  </button>
                  <span>{quantity}</span>
                  <button onClick={() => setQuantity((q) => q + 1)}>+</button>
                </div>
              </div>

              {/* Countdown */}
              <div className="countdown_box">
                <div className="countdown_block">
                  <span className="cd_num">{pad(time.hours)}</span>
                  <span className="cd_label">Hours</span>
                </div>
                <span className="cd_sep">:</span>
                <div className="countdown_block">
                  <span className="cd_num">{pad(time.minutes)}</span>
                  <span className="cd_label">Minutes</span>
                </div>
                <span className="cd_sep">:</span>
                <div className="countdown_block">
                  <span className="cd_num">{pad(time.seconds)}</span>
                  <span className="cd_label">Seconds</span>
                </div>
              </div>

              {/* Offers */}
              <div className="offers_box">
                <div className="offers_top">
                  <span>Offers</span>
                  <span className="razorpay_tag">
                    powered by <strong>Razorpay</strong>
                  </span>
                </div>
                <div className="offers_body">
                  <span className="offer_icon">🏷️</span>
                  <span className="offer_text">
                    Savings of <strong>₹30</strong> with offers
                  </span>
                  <button className="view_offers_btn">View offers →</button>
                </div>
              </div>

              <button
                className="buy_btn"
                onClick={() => navigate("/checkout-details")}
              >
                Buy it now
              </button>

              <div className="product_divider" />

              <p className="product_desc">
                Experience the power of Ayurveda with{" "}
                <strong>Light N Care Anti Blemish Cream</strong>, enriched with{" "}
                <strong>Green Tea and Aloe Vera Extract</strong>. This
                all-natural formula is specially crafted to reduce blemishes and
                pigmentation, promoting visibly healthier and clearer skin.
              </p>

              <div className="product_divider" />
              <h6 className="section_label">Key Benefits:</h6>
              <ul className="benefits_list">
                <li>🌿 Reduces Blemishes & Pigmentation</li>
                <li>🌱 Enriched with Green Tea & Aloe Vera Extract</li>
                <li>🌼 Promotes Healthy, Clear & Radiant Skin</li>
                <li>✨ Lightweight & Non-Greasy Texture</li>
                <li>🏺 Authentically Ayurvedic Formula</li>
                <li>🤍 Gentle for All Skin Types</li>
              </ul>

              <div className="product_divider" />
              <h6 className="section_label">How to Use:</h6>
              <ol className="how_to_list">
                <li>Cleanse your face thoroughly.</li>
                <li>Apply a small amount of cream evenly on affected areas.</li>
                <li>Use twice daily for best results.</li>
              </ol>

              <div className="product_divider" />
              <h6 className="section_label">Ingredients:</h6>
              <ul className="benefits_list">
                <li>
                  <strong>Green Tea Extract</strong> – Rich in antioxidants,
                  helps reduce inflammation and acne.
                </li>
                <li>
                  <strong>Aloe Vera Extract</strong> – Soothes and hydrates the
                  skin naturally.
                </li>
                <li>
                  <strong>Ayurvedic Herbs</strong> – Time-tested ingredients
                  that nourish and heal skin imperfections.
                </li>
              </ul>
              <div className="product_divider" />
              <h6 className="section_label">Suitable For:</h6>
              <ul className="benefits_list">
                <li>✔ All Skin Types</li>
                <li>✔ Men & Women</li>
                <li>✔ Daily Use</li>
              </ul>

              <div className="product_divider" />
              <h6 className="section_label">Why Choose Light N Care?</h6>
              <p className="product_desc">
                Backed by {title} Medicos, this cream is made in
                Malerkotla, Punjab (India) with authentic Ayurvedic
                formulations. We prioritize skin wellness through natural,
                chemical-free solutions.
              </p>

              {/* Product Details Table */}
              <div className="product_divider" />
              <h6 className="section_label">
                📦 Product Details (Shopify Fields):
              </h6>
              <div className="product_table">
                <div className="table_row">
                  <span className="table_label">Vendor</span>
                  <span className="table_value">{title} Medicos</span>
                </div>
                <div className="table_row">
                  <span className="table_label">Product Type</span>
                  <span className="table_value">Skin Care / Face Cream</span>
                </div>
                <div className="table_row">
                  <span className="table_label">SKU</span>
                  <span className="table_value">LNC-ANTI-BLEMISH-50G</span>
                </div>
                <div className="table_row">
                  <span className="table_label">Weight</span>
                  <span className="table_value">50g (grams)</span>
                </div>
                <div className="table_row">
                  <span className="table_label">HSN Code</span>
                  <span className="table_value">3304</span>
                </div>
                <div className="table_row">
                  <span className="table_label">Tags</span>
                  <span className="table_value">
                    anti-blemish, pigmentation, ayurvedic, green tea, aloe vera,
                    skincare, light n care, herbal, natural
                  </span>
                </div>
              </div>

              {/* Shipping Info */}
              <div className="product_divider" />
              <h6 className="section_label">📦 Shipping Info:</h6>
              <p className="product_desc">
                Ships within 3–4 business days.
                <br />
                Available for pan-India delivery.
              </p>

              {/* Customer Care */}
              <div className="product_divider" />
              <h6 className="section_label">📋 Customer Care Info:</h6>
              <p className="product_desc">For queries, contact us at:</p>
              <p className="product_desc">
                📞 <strong>+91 98883-09794</strong>
              </p>

              {/* Share */}
              <div className="product_divider" />
              <button className="share_btn">
                <i className="fa-solid fa-share-from-square" /> Share
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

// ────────────────────────────────────────────
//  ALL PRODUCTS (tumhara existing code — unchanged)
// ────────────────────────────────────────────
const Product_view = () => {
  const navigate = useNavigate();

  const products = [
    {
      id: 1,
      title: "( Jiwandan )Immunity Booster...",
      subtitle: "{title}",
      originalPrice: "2,499.00",
      salePrice: "1,799.00",
      badge: "Sale",
      img: product_img1,
    },
    {
      id: 2,
      title: "HYDRATING SUNSCREEN...",
      subtitle: "{title}",
      originalPrice: "650.00",
      salePrice: "450.00",
      badge: "Sale",
      img: product_img3,
    },
    {
      id: 3,
      title: "Light N Care Anti Blemish Cream...",
      subtitle: "{title}",
      originalPrice: "399.00",
      salePrice: "299.00",
      badge: "Sale",
      img: product_img4,
    },
  ];

  return (
    <div className="allProduct_sec">
      <Container>
        <Row>
          {products.map((product) => (
            <Col lg={4} md={6} sm={12} key={product.id} className="mb-4">
              <div className="product_card_new">
                <div className="card_images">
                  <img src={product.img} alt="img" className="img_mains" />
                  <img src={product.img} alt="img" className="img_clones" />
                </div>
                <div className="sale_badges">{product.badge}</div>
                <div className="card_contentss">
                  <h3 className="product_titles">{product.title}</h3>
                  <p className="product_subtitles">{product.subtitle}</p>
                  <div className="price_blocks">
                    <span className="original_prices">
                      Rs. {product.originalPrice}
                    </span>
                    <span className="sale_prices">Rs. {product.salePrice}</span>
                  </div>
                  <button
                    className="add_to_cart_btns"
                    onClick={() => navigate("/cart")}
                  >
                    Add to cart
                  </button>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </div>
  );
};

// ────────────────────────────────────────────
//  MAIN EXPORT — dono ek saath
// ────────────────────────────────────────────
const ProductPage = () => {
  return (
    <>
      <ProductDetail />
      <Product_view />
    </>
  );
};

export default ProductPage;
